"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacebookError = void 0;
var FacebookError;
(function (FacebookError) {
    FacebookError["BUSINESS_USER_NOT_FOUND"] = "BUSINESS_USER_NOT_FOUND";
    FacebookError["FB_USER_IS_NOT_ADMIN"] = "FB_USER_IS_NOT_ADMIN";
    FacebookError["INVALID_OAUTH_ACCESS_TOKEN"] = "INVALID_OAUTH_ACCESS_TOKEN";
    FacebookError["MULTIPLE_SHOPIFY_PRODUCT_CATALOGS"] = "MULTIPLE_SHOPIFY_PRODUCT_CATALOGS";
    FacebookError["REFRESH_ALREADY_IN_PROGRESS"] = "REFRESH_ALREADY_IN_PROGRESS";
    FacebookError["SELLER_NOT_FOUND"] = "SELLER_NOT_FOUND";
    FacebookError["SHOPIFY_PRODUCT_CATALOG_NOT_FOUND"] = "SHOPIFY_PRODUCT_CATALOG_NOT_FOUND";
})(FacebookError = exports.FacebookError || (exports.FacebookError = {}));
//# sourceMappingURL=FacebookError.js.map